module.exports = __webpack_public_path__ + "assets/60d2c97d3bf67b7e263262f49cefd488.svg";


//////////////////
// WEBPACK FOOTER
// ./app/documents/assets/docs.svg
// module id = 667
// module chunks = 0